import React from "react";
import { motion } from "framer-motion";
import RecFinal from "../assets/RecFinal.mp4";
const Card3 = () => {
  return (
    <motion.div
      initial={"hidden"}
      whileInView={"visible"}
      variants={{
        visible: { opacity: 1 },
        hidden: { opacity: 0 },
      }}
      class="max-w-xl bg-white rounded-lg border border-gray-200 shadow-lg bg-gray-100 dark:border-gray-700 my-8"
    >
      <video className="rounded-t-lg w-full" controls>
        <source src={RecFinal} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div class="p-5">
        <a href="https://github.com/nick3948/Stark-main" target="_blank" rel="noopener noreferrer">
          <h5 class="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-black hover:text-blue-500 transition-colors duration-300 cursor-pointer">
            Stark Voice Assistant
          </h5>
        </a>
        <p class="mb-3 font-normal text-gray-700 dark:text-black-400">
          Developed an interactive voice assistant using Python and Qt Designer, enabling real-time responses to user
          commands and information retrieval, showcasing skills in both programming logic and UI design.</p>
      </div>
    </motion.div>
  );
};

export default Card3;
